import script from "./ZiwoWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./ZiwoWindow.vue?vue&type=script&setup=true&lang=js"

import "./ZiwoWindow.vue?vue&type=style&index=0&id=772e053a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772e053a"]])

export default __exports__